import Landing from "@/pages/Landing";

/**
 * Standard (no-VSL) landing page at `/`.
 *
 * We do NOT auto-detect currency here — if we can't be certain the visitor is
 * in the US, we default to the UK/£ experience. Anyone who actually wants the
 * US version can hit /us directly.
 */
export default function StandardLanding() {
  return <Landing marketKey="uk" showVSL={false} />;
}
